import { BadgeCheck, Phone, ShieldCheck, Star } from 'lucide-react';

export const TrustBadge = ({ type = 'phone', size = 'sm', withLabel = true }) => {
  const cfg = {
    phone: { icon: Phone, label: 'Tél. vérifié', bg: 'bg-[#EAF3FF]', fg: 'text-[#0F5FCC]', border: 'border-[#C7E2FF]' },
    id: { icon: ShieldCheck, label: 'Identité vérifiée', bg: 'bg-[#DFF7EA]', fg: 'text-[#16764A]', border: 'border-[#1F9D63]/30' },
    trusted: { icon: Star, label: 'Jobeur de confiance', bg: 'bg-[#FFF6C7]', fg: 'text-[#7A5F00]', border: 'border-[#C9A800]/40' },
    verified: { icon: BadgeCheck, label: 'Vérifié', bg: 'bg-[#EAF3FF]', fg: 'text-[#0F5FCC]', border: 'border-[#C7E2FF]' },
  }[type];
  const Icon = cfg.icon;
  const px = size === 'xs' ? 'px-1.5 py-0.5 text-[10px]' : size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs';
  const ic = size === 'xs' ? 10 : size === 'sm' ? 12 : 14;
  return (
    <span
      data-testid={`trust-badge-${type}`}
      className={`inline-flex items-center gap-1 rounded-full border ${cfg.bg} ${cfg.fg} ${cfg.border} ${px} font-semibold`}
    >
      <Icon size={ic} />
      {withLabel && <span>{cfg.label}</span>}
    </span>
  );
};

export const UserBadges = ({ user, size = 'sm' }) => {
  if (!user) return null;
  return (
    <div className="flex flex-wrap gap-1.5">
      {user.phone_verified && <TrustBadge type="phone" size={size} />}
      {user.id_verified && <TrustBadge type="id" size={size} />}
      {user.trusted_jobeur && <TrustBadge type="trusted" size={size} />}
    </div>
  );
};
